/**
 * Validates that an email address belongs to the @royalcyber.com domain.
 * Comparison is case-insensitive on the domain portion.
 *
 * @param email - The email address to validate
 * @returns true if the email ends with "@royalcyber.com" (case-insensitive)
 */
export function validateEmailDomain(email: string): boolean {
  if (!email || typeof email !== 'string') {
    return false;
  }

  const domain = email.split('@').pop();
  if (!domain) {
    return false;
  }

  return domain.toLowerCase() === 'royalcyber.com';
}
